// src/pages/RegisterCliente.jsx
import React from "react";
import Card from "../../../components/Global/Card";
import { AiOutlineIdcard } from "react-icons/ai";
import RegisterClienteForm from "../../../components/Forms/RegisterClienteForm";
import GoBack from "../../../components/Utils/GoBack";

function RegisterCliente() {
  return (
    <div className="flex flex-col w-full gap-3">
      <GoBack path="/clientes" />
      <Card
        title="Cadastro de Cliente"
        icon={<AiOutlineIdcard className="w-[25px] h-[25px]" />}
      >
        <div className="p-4 flex flex-col gap-5 w-full">
          <RegisterClienteForm />
        </div>
      </Card>
    </div>
  );
}

export default RegisterCliente;
